import React from 'react';
import PropTypes from 'prop-types';
import capitalize from '../../../stringUtils';
import './ProjectEmploymentType.scss';

function ProjectEmploymentType({ employmentType, showProjectEmploymentType }) {
  return showProjectEmploymentType
  && (
  <div
    className={`${employmentType}-badge`}
  >
    {capitalize(employmentType)}
    {' '}
    Position
  </div>
  );
}

ProjectEmploymentType.prototype = {
  employmentType: PropTypes.string,
  showProjectEmploymentType: PropTypes.bool,
};

ProjectEmploymentType.defaultProps = {
  employmentType: '',
  showProjectEmploymentType: false,
};

export default ProjectEmploymentType;
